/**
 * quick-capture-store.js
 *
 * Module-level singleton that carries a File object from the QuickCaptureModal
 * (rendered in App.js) to LogReports (formerly TimesheetPage), which reads it
 * on mount.
 *
 * This avoids prop-drilling through App → DashboardLayout → LogReports
 * and keeps the file reference in memory for the lifetime of the navigation.
 *
 * Usage:
 *   setQuickCaptureFile(file)  — store the File picked in QuickCaptureModal
 *   getQuickCaptureFile()      — read it once (LogReports on mount)
 *   clearQuickCaptureFile()    — call immediately after consuming
 */

let _file = null;

export function setQuickCaptureFile(file) {
    _file = file;
}

export function getQuickCaptureFile() {
    return _file;
}

export function clearQuickCaptureFile() {
    _file = null;
}
